const initialState = {
    rulesFromIsOpen: false,
    rulesBtnShow: false,
    assignFromIsOpen: false,
    approveFromIsOpen: false,
    showBulkAssignBtn: false,
    showNewRuleBtn: false,
    showApproveBtn: false,
    showAddSalaryBtn: false
}

const payrollReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'HANDLE_ADD_RULE_FORM':
            if (action.value.type === "showBtn") {
                return { ...state, rulesBtnShow: action.value.value }
            } else if (action.value.type === "openForm") {
                return { ...state, rulesFromIsOpen: action.value.value }
            }
            break
        case 'HANDLE_ASSIGN_FORM':
            if (action.value.type === "showBtn") {
                return { ...state, showBulkAssignBtn: action.value.value }
            }
            return { ...state, assignFromIsOpen: action.value }
            break
        case 'HANDLE_PAYROLL_LEAVE':
            if (action.value.type === "showBtn") {
                return { ...state, showNewRuleBtn: action.value.value }
            }
            break
        case 'HANDLE_APPROVE_FORM':
            if (action.value.type === "showApproveBtn") {
                return { ...state, showApproveBtn: action.value.value }
            }
            return { ...state, approveFromIsOpen: action.value }
            break
        case 'HANDLE_PAYROLL_MANAGE_PAYROLL':
            if (action.value.type === "showAddSalaryBtn") {
                return { ...state, showAddSalaryBtn: action.value.value }
            }
            break
        default:
            return state
    }
}

export default payrollReducer